module.exports = __webpack_public_path__ + "img/inst-news-bg-mob.7a73360d.svg";